import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { productImportWarehouseBusiness } from "api/bussiness/product/product-import-warehouse-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddProductGoodsReceipt } from "mobx-stores/_models/product-inventory/product-goods-receipt/product-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddProductGoodsReceiptSchema } from "./schema";

export const AddProductGoodsReceipt = observer(() => {
  const {
    productInventoryManagement: {
      productGoodsReceiptStore: { openNew, getProductGoodsReceipt, setProp },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<IAddProductGoodsReceipt>(getAddProductGoodsReceiptSchema(), {
    importDate: dateTimeToUTCString(dayjs()),
    items: [
      {
        productId: "",
        location: "",
        note: "",
        quantity: 0,
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddProductGoodsReceipt) => {
      try {
        await productImportWarehouseBusiness.add(data);
        await getProductGoodsReceipt();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getProductGoodsReceipt, setProp]
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm nhập kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
